import React, { useEffect, useState, useRef } from "react";
import { getBlogContentApi } from "../../apiCalls/apiCalls";
import CardMedia from "@mui/material/CardMedia";
import CardContent from "@mui/material/CardContent";
import Card from "@mui/material/Card";
import { useNavigate } from "react-router-dom";
import FooterComponent from "../footer";
import GetInTouchComponent from "../getInTouch";
import HeaderComponent from "../header";
import "../../styles/blogs/style.scss";

const BlogHomePage = ({ headerName, subHeaderName, ref }) => {
  const navigate = useNavigate();
  const [html, setHTML] = useState();
  const refs = {
    Home: useRef(null),
    Services: useRef(null),
    "Case Studies": useRef(null),
    Blog: useRef(null),
    Contact: useRef(null),
    About: useRef(null),
  };

  const handleScrollToPortion = (section) => {
    if (section === "Contact") {
      refs[section]?.current?.scrollIntoView({ behavior: "smooth" });
    } else if (section === "About") {
      navigate(`/aboutUs`);
    } else {
      navigate("/", { state: { scrollTo: section } });
    }
  };

  const getBlogsContentFunc = () => {
    getBlogContentApi().then((data) => {
      if (data) {
        setHTML(data.data);
      } else {
        console.log("Error fetching HTML content");
      }
    });
  };

  useEffect(() => {
    getBlogsContentFunc();
  }, []);

  const blogCardContentFunc = (data) => {
    navigate(`/blog/${data.heading}/${data._id}`);
  };

  return (
    <>
      <HeaderComponent handleScrollToPortion={handleScrollToPortion} />
      <div className="blogs-main-wrapper">
        {html?.map((data) => {
          return (
            <Card
              key={data.id}
              className="blogs-card"
              onClick={() => {
                blogCardContentFunc(data);
              }}
            >
              <CardMedia
                className="blog-card-image"
                component="img"
                image={data.image}
                alt="financial"
              />
              <CardContent className="blogs-card-content-wrapper">
                <div className="blogs-card-content-main-wrapper">
                  <h2 className="blog-card-heading">{data.heading}</h2>
                  <div className="blog-card-content">
                    {data.blogIntroduction}
                  </div>
                  <div className="blog-card-know-more-date-wrapper">
                    <div>
                      {new Date(data?.createdAt).toLocaleDateString("en-US", {
                        year: "numeric",
                        month: "long",
                        day: "numeric",
                      })}
                    </div>
                    <button className="blog-know-more-button">Know More</button>
                  </div>
                </div>
              </CardContent>
            </Card>
          );
        })}
      </div>
      <GetInTouchComponent ref={refs.Contact} />
      <FooterComponent
        handleScrollToPortion={handleScrollToPortion}
        ref={refs.About}
      />
    </>
  );
};

export default BlogHomePage;
